<template>
  <v-dialog v-model="dialogAddGroup" persistent max-width="600px">
    <v-card class="pa-4">
      <v-card-title>
        <span class="dialog-member-title">เพิ่มกลุ่มระดับตำแหน่งงาน</span>
        <v-row justify="end" style="margin-top: -3%;">
          <v-btn
            x-small
            icon
            @click="closeDialog()"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-row>
      </v-card-title>
      <v-card-text>
        <v-row justify="center">
          <v-col cols="12" class="mt-n2">
            <v-divider></v-divider>
          </v-col>
          <v-col cols="12" class="d-flex align-center justify-end pa-0">
            <v-btn class="" dark outlined @click="addGroupPosition()">
              <v-icon left dark class="icon-eye-color" size="14px">fa-plus</v-icon>
              <span class="icon-eye-color ra-text-in-button-position">เพิ่มกลุ่มระดับตำแหน่ง</span>
            </v-btn>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-form ref="form" class="overflow-x-hidden overflow-y-auto" style="max-height: 400px;">
              <div v-for="(input, k) in groupList" :key="k" class="pa-0 ma-0">
                <v-card class="mx-auto px-0 mb-5" style="border: 1px solid #EEEEEE;" elevation="0">
                  <v-row style="background-color: #EFF4FD" class="pa-0 ma-0">
                    <v-col cols="10">
                      <v-col
                        cols="10"
                        class="pa-0 d-flex flex-row justify-start"
                      >
                        <span class="txt-head"
                          >ลำดับที่ {{ k + 1 }}<span class="ml-1"></span
                          ><span
                            class="txt-font"
                            style="color: grey; font-size: 14px;"
                            >&nbsp;(</span
                          ><span style="color: red;">*</span
                          ><span
                            class="txt-font"
                            style="color: grey; font-size: 14px;"
                            >กรอกข้อมูลให้ครบถ้วน)</span
                          ></span
                        >
                      </v-col>
                    </v-col>
                    <v-col
                      v-if="groupList.length > 1"
                      cols="2"
                      class="pa-0 d-flex flex-row align-center justify-end"
                    >
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            v-bind="attrs"
                            v-on="on"
                            dark
                            icon
                            tile
                            class="mr-2"
                            @click="removeGroupPosition(k)"
                            v-show="k || (!k && groupList.length > 1)"
                          >
                            <template v-slot>
                              <v-icon dark color="#D1392B" size="19px"
                                >mdi-delete-outline</v-icon
                              >
                            </template>
                          </v-btn>
                        </template>
                        <span class="label-table-action">ลบข้อมูล</span>
                      </v-tooltip>
                    </v-col>
                  </v-row>
                  <v-row class="pl-5 pr-5 pt-2 pb-2 mb-n2">
                    <v-col cols="12" class="form-control pa-2">
                      <span>ชื่อกลุ่ม</span>
                      <v-text-field
                        v-model="groupList[k].positionGroupName"
                        dense
                        outlined
                        @input="handleInputChange(k, groupList[k].positionGroupName)"
                        @keydown="validateKeydown($event)"
                        placeholder="ชื่อกลุ่ม"
                        :rules="[duplicateNameRule(k)]"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-card>
              </div>
            </v-form>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="button-color-outline" dark outlined @click="closeDialog()">ยกเลิก</v-btn>
          <v-btn v-if="checkValueList === false || isDuplicate.size > 0 || isCheckDuplicate" class="button-color" color="grey" disabled>บันทึกข้อมูล</v-btn>
          <v-btn v-else class="button-color" dark @click="submitData()">บันทึกข้อมูล</v-btn>
      </v-card-actions>
      <div class="text-center">
        <v-snackbar
          v-model="snackbar"
          :timeout="timeout"
          :color="snackbarColor"
          absolute
          text
          top
          app
        >
          <v-icon left dark small :color="snackbarColor">fa-check-circle</v-icon>
          <span :style="{ color: `${snackbarColor}` }">{{ text }}</span>
        </v-snackbar>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import {
  createPositionLevelGroup,
  validateDuplicateGroupName
} from '@/API/API'
import { EventBus } from '@/EventBus'
import swal from 'sweetalert'

export default {
  data () {
    return {
      snackbar: false,
      timeout: 2000,
      snackbarColor: '',
      debounceTimeout: {},
      text: '',
      dialogAddGroup: false,
      isDuplicate: new Set(),
      isCheckDuplicate: false,
      groupList: [
        {
          positionGroupName: ''
        }
      ]
    }
  },
  beforeDestroy () {
    EventBus.$off('opendialogAddGroup')
  },
  mounted () {
    EventBus.$on('opendialogAddGroup', this.openDialogAddGroup)
  },
  methods: {
    openDialogAddGroup (value) {
      this.dialogAddGroup = value
    },
    closeDialog () {
      this.groupList = [
        {
          positionGroupName: ''
        }
      ]
      this.$refs.form.resetValidation()
      this.dialogAddGroup = false
    },
    addGroupPosition () {
      this.groupList.push({
        positionGroupName: ''
      })
    },
    removeGroupPosition (index) {
      this.groupList.splice(index, 1)
      this.text = 'คุณได้ทำการลบข้อมูลเรียบร้อยแล้ว'
      this.snackbarColor = 'success'
      this.snackbar = true
    },
    validateKeydown (event) {
      const key = event.key
      const cursorPos = event.target.selectionStart
      if (key === 'Backspace' || /[0-9a-zA-Zก-๙]/.test(key)) {
        return
      }
      if (key === ' ') {
        if (cursorPos === 0) {
          event.preventDefault()
        }
        return
      }
      event.preventDefault()
    },
    handleInputChange (index, value) {
      if (this.debounceTimeout[index]) {
        clearTimeout(this.debounceTimeout[index])
      }
      this.isCheckDuplicate = true
      this.debounceTimeout[index] = setTimeout(async () => {
        if (value && value !== '') {
          this.groupList[index].positionGroupName = value.trim()
          await this.checkDuplicateFromAPI(index, value)
          if (this.isDuplicate.has(index)) {
            this.text = 'ชื่อกลุ่ม ซ้ำกับภายในระบบ'
            this.snackbarColor = 'error'
            this.snackbar = true
          }
        }
      }, 500)
    },
    async submitData () {
      if (this.$refs.form.validate() && this.isDuplicate.size === 0) {
        try {
          const data = {
            positionGroupNameList: this.groupList.map(item => item.positionGroupName)
          }
          const res = await createPositionLevelGroup(data, this.$store.state.token)
          if (res.success) {
            swal('สำเร็จ', 'เพิ่มกลุ่มระดับตำแหน่งงานสำเร็จ', 'success', {
              button: false,
              timer: 2000
            })
            this.closeDialog()
          }
          EventBus.$emit('closedialogAddGroup')
        } catch (error) {
          console.error(error)
        }
      }
    },
    duplicateNameRule (index) {
      return (value) => {
        const normalizedValue = value.trim().toLowerCase()
        const names = this.groupList
          .map((item, i) => i !== index ? item.positionGroupName.trim().toLowerCase() : null)
          .filter(name => name !== null)
        const isDuplicate = names.includes(normalizedValue)
        return isDuplicate ? 'ชื่อกลุ่ม ซ้ำกัน' : true
      }
    },
    async checkDuplicateFromAPI (index, value) {
      const token = this.$store.state.token
      if (this.isDuplicate.has(index)) {
        this.isDuplicate.delete(index)
      }
      try {
        const res = await validateDuplicateGroupName(value, token)
        if (!res.success) {
          this.isDuplicate.add(index)
        }
        this.isCheckDuplicate = false
      } catch (error) {
        this.isCheckDuplicate = false
      }
    }
  },
  computed: {
    checkValueList () {
      return this.groupList.every(item => item.positionGroupName !== '')
    }
  }
}
</script>

<style scoped>
@import '../../../css/ManageEmployee.css';
.dialog-memeber-title {
  font-family: 'Sarabun', sans-serif !important;
  font-weight: bold;
  font-size: 1.2rem;
}
</style>
